module.exports = __webpack_public_path__ + "img/search-icon.e5577708.svg";